import type { Major } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import {
  getMajorEarningsRating,
  AVERAGE_MEDIAN_EARLY_CAREER_WAGE,
  AVERAGE_MEDIAN_MID_CAREER_WAGE,
} from '@backrs_ui/grow-ui/src/pages/Majors/majors.utils';

export const useAgentContext = (major: Major) => {
  const { rating } = getMajorEarningsRating(major);

  useRegisterAgentContext({
    kind: 'section',
    title: 'Earnings',
    description:
      'Early-career and mid-career median wages for this major compared to the average across all majors',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Earnings Comparison Chart',
    display:
      'Bar chart comparing early-career and mid-career median wages for this major vs average, with a rating badge and legend',
    data: {
      rating,
      medianWageEarlyCareer: major.medianWageEarlyCareer,
      medianWageMidCareer: major.medianWageMidCareer,
      averageEarlyCareerWage: AVERAGE_MEDIAN_EARLY_CAREER_WAGE,
      averageMidCareerWage: AVERAGE_MEDIAN_MID_CAREER_WAGE,
    },
  });
};
